import { Component, OnInit } from '@angular/core';
import { BaseAccountInfoComponent } from '../../BaseAccountInfo/BaseAccountInfo.component';
import { AccountInfoService } from '../../../services/account-info.service';
import { SurveyNeedingApprovalModel } from '../../../api/models';
import { ReportService } from '../../../api/services';
import { ToastService } from '../../../services/toast.service';
import { GetSurveysNeedingApprovalReport$Json$Params } from '../../../api/fn/report/get-surveys-needing-approval-report-json';

@Component({
  selector: 'app-surveys-needing-approval-grid',
  templateUrl: './surveys-needing-approval-grid.component.html',
  styleUrl: './surveys-needing-approval-grid.component.scss'
})
export class SurveysNeedingApprovalGridComponent 
  extends BaseAccountInfoComponent
  implements OnInit 
{

  isReportLoading: boolean = false;
  surveys: SurveyNeedingApprovalModel[] = [];

  constructor(
    private reportService: ReportService,
    private toastService: ToastService,
    protected override accountInfoService: AccountInfoService
  ) {
    super(accountInfoService);
  }

  override ngOnInit() {
    super.ngOnInit();

    // Trigger a function when accountInfo is fully loaded
    this.accountInfoService.accountInfo$.subscribe((accountInfo) => {
      if (accountInfo?.isLoaded) {
        this.accountInfo = accountInfo; // Set the accountInfo in the base class
        this.getSurveysNeedingApproval(); // Call the function when accountInfo is loaded
      }
    });
  
  }

  getSurveysNeedingApproval() {
    if (this.isReportLoading === true) {
      // Avoid concurrent duplicate http requests if already loading.
      return;
    }
    this.isReportLoading = true;

    let params: GetSurveysNeedingApprovalReport$Json$Params = {
      clientRepId: this.accountInfo?.isAdmin ? undefined : this.accountInfo?.repId!
    };
    this.reportService.getSurveysNeedingApprovalReport$Json$Response(params).subscribe({
      next: (response) => {
        if (!response.body) {
          console.error(response.body);
          this.toastService.showToast('danger', 'Problem loading surveysneedingapproval report');
        }
        else {
          this.surveys = [...response.body];
        }

        this.isReportLoading = false;
      },
      error: (e) => {
        this.isReportLoading = false;
        console.error('Error loading surveysneedingapproval report:', e);
        this.toastService.showToast('danger', 'Problem loading surveysneedingapproval report');
      }
    });
  }
}
